import 'altcha'
import 'altcha/i18n/de'

const de = $altcha.i18n.get('de')
if (de?.footer) {
  $altcha.i18n.set('de', {
    ...de,
    footer: de.footer.replace('https://altcha.org/', 'https://altcha.org/de/'),
  })
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.$) window.$('.captcha-field [data-toggle="tooltip"]').tooltip()
})
